export const ADMIN_LABELS = {
  EDIT_SUBMIT_BUTTON: 'Zapisz',
  EDIT_SUBMIT_BUTTON_LOADING: 'Zapisywanie…',
} as const;
